import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StringReplacePipe } from '../pipes/string-replace.pipe';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { VideoUrlPipe } from '../pipes/video-url.pipe';
import { DistanceMilesPipe } from '../pipes/distance-miles.pipe';
import { FooterComponent } from '../components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    StringReplacePipe,
    SafeHtmlPipe,
    DistanceMilesPipe,
    VideoUrlPipe,
    FooterComponent
  ],
  exports: [
    StringReplacePipe,
    SafeHtmlPipe,
    VideoUrlPipe,
    DistanceMilesPipe,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class SharedModule { }
